import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";



const Table15 = ({ azadiAmalScore, setAzadiAmalScore, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)


  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.azadiAmal;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 8, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 16, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 24, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 32, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },

      ]


      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      setAzadiAmalScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "azadiAmal": selectedItem }))
    }
  }, [reload])

  return (
    <div>
      <Row type={1}>
        <Column >سطح یک</Column>
        <Column >سطح دو</Column>
        <Column >سطح سه</Column>
        <Column >سطح چهار</Column>
        <Column >سطح پنج</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          اختیار محدود، آزادی
          عمل کم، انجام کارها
          مطابق دستورالعمل
        </Column>
        <Column paddingY={30}>
          اختیار نسبتاً محدود،
          آزادی عمل متوسط،
          انجام کار بر اساس اصول
          استاندارد
        </Column>
        <Column paddingY={30}>
          اختیار و ابتکار عمل
          متوسط، آزادی عمل
          زیاد، انجام کار بر
          اساس اصول تنظیم
          شده کلی
        </Column>
        <Column paddingY={30}>
          اختیار زیاد، آزادی
          عمل خیلی زیاد،
          انجام کار بر اساس
          اصول هدایت شده و
          جهت دار
        </Column>
        <Column paddingY={30}>
          اختیار عمل نامحدود،
          آزادی عمل وسیع، انجام
          کار بر اساس رهنمودهای
          کلی و گسترده
        </Column>
      </Row>
      <Row>
        <Column isActive={azadiAmalScore == 8}> 8</Column>
        <Column isActive={azadiAmalScore == 16}>16 </Column>
        <Column isActive={azadiAmalScore == 24}>24 </Column>
        <Column isActive={azadiAmalScore == 32}> 32</Column>
        <Column isActive={azadiAmalScore == 40}> 40</Column>
      </Row>
    </div>
  );
};

export default Table15;
